import React from 'react'

import styled from 'styled-components'

import { formatDate } from 'src/Constants/formatDate'
import dayjs from 'src/Helpers/dayjs'
import { MAX_TABLET_WIDTH } from 'src/Styled/variables'

import { ArtistBalanceItemProps } from '.'

type ArtistBalanceItemDateProps = Pick<ArtistBalanceItemProps, 'date'>

const Container = styled.div`
  display: none;

  @media screen and (min-width: ${MAX_TABLET_WIDTH}) {
    display: flex;
    width: 180px;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: ${({ theme }) => theme.color.darkGrey};
    font-family: 'Segoe UI';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
`
export const ArtistBalanceItemDate: React.FC<ArtistBalanceItemDateProps> = ({
  date,
}) => (
  <Container>
    {date ? dayjs(date).format(formatDate.formatDate1) : ''}
  </Container>
)
